import { render, staticRenderFns } from "./setup_profile_by_button.vue?vue&type=template&id=5925ede7&"
import script from "./setup_profile_by_button.vue?vue&type=script&lang=js&"
export * from "./setup_profile_by_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports